import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        return;
      }

      $( '.click-to-play-collage' ).each( function() {
        const graphics = $( this ).find( '.click-to-play-collage__graphic' ).toArray();

        if ( !graphics.length ) {
          return;
        }

        graphics.forEach( ( graphic, index ) => {
          gsap.fromTo(
              graphic,
              {
                autoAlpha: 0,
                y: 140,
              },
              {
                autoAlpha: 1,
                y: 0,
                duration: 1.2,
                ease: 'power3.out',
                scrollTrigger: {
                  trigger: graphic,
                  start: 'top 95%',
                  once: true,
                },
              },
          );
        } );
      } );
    },

    finalize: function() {},
  };
  app.registerComponent( 'click-to-play-collage', COMPONENT );
} )( app );
